import { COMMONS_IMAGES_DATA_SOURCE, CommonsImagesDataSource } from "@jack-sparrow-libraries/angular-business-commons";
import { inject, Injectable, untracked } from "@angular/core";
import { AgatheYouCareService } from "@services/agathe-you-care.service";
import { AgatheYouCareAssets } from "@core/constantes/agathe-you-care.constant";

@Injectable()
export class ImagesSourceService implements CommonsImagesDataSource {
	private readonly agatheYouCareService = inject(AgatheYouCareService);

	// `untracked` évite seulement le suivi du signal : l'image reste figée parce que `commons-loader`
	// (angular-business-commons) est en OnPush et appelle cette méthode depuis son template.
	getLoadingImage(): string {
		return untracked(this.agatheYouCareService.$isCare)
			? AgatheYouCareAssets.LOADER
			: AgatheYouCareAssets.LOADING_IMAGE_AY;
	}
}

export const provideCommonsImagesDataSource = () => ({
	provide: COMMONS_IMAGES_DATA_SOURCE,
	useClass: ImagesSourceService,
});
